import { render, staticRenderFns } from "./search-translate.vue?vue&type=template&id=dd63e3e4"
import script from "./search-translate.vue?vue&type=script&lang=js"
export * from "./search-translate.vue?vue&type=script&lang=js"
import style0 from "./search-translate.vue?vue&type=style&index=0&id=dd63e3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports